export default __webpack_public_path__ + "static/media/png.511f2de9.png";